import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin, FiInstagram, FiFacebook, FiTwitter, FiYoutube, FiArrowRight, FiExternalLink } from 'react-icons/fi';
import { GiPartyPopper } from 'react-icons/gi';
import '../assets/css/styles.css';

export default function Footer() {
  return (
    <footer className="relative">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23f8c630' fill-opacity='0.3' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='3'%3E%3C/circle%3E%3Ccircle cx='13' cy='13' r='3'%3E%3C/circle%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      {/* Main Footer */}
      <div className="bg-gradient-to-br from-primary to-primary-500 relative">
        <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-primary via-secondary to-accent opacity-90"></div>

        {/* Decorative lights */}
        <div className="absolute left-0 top-[20%] w-[250px] h-[250px] rounded-full bg-secondary/5 blur-[100px]"></div>
        <div className="absolute right-0 top-[40%] w-[350px] h-[350px] rounded-full bg-accent/5 blur-[120px]"></div>

        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto pt-20 pb-12 px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
            {/* Brand Section */}
            <div className="md:col-span-5 lg:col-span-4">
              <Link to="/" className="flex items-center gap-3 mb-6 group">
                <div className="relative h-12 w-12 flex items-center justify-center rounded-xl overflow-hidden bg-white/10 backdrop-blur-sm border border-white/10 shadow-inner">
                  <div className="absolute inset-0 bg-gradient-to-br from-primary-800 to-primary opacity-50"></div>
                  <img src="/icon-white.jpeg" alt="Happy Bubble Logo" className="w-15 h-15 object-contain relative z-10" />
                </div>
                <div>
                  <h3 className="text-xl font-display font-bold text-black mb-0 leading-tight group-hover:text-secondary transition-colors">
                    Happy Bubble
                  </h3>
                  <p className="text-xs text-secondary/80 font-medium tracking-wider">PRIVATE THEATERS</p>
                </div>
              </Link>

              <p className="text-black mb-6 leading-relaxed text-sm max-w-md">
                Elevate your special moments with Happy Bubble. We offer unique theatre spaces for birthdays, meetings, photoshoots, and more with customizable options and professional services to create unforgettable experiences.
              </p>

              <div className="rounded-xl overflow-hidden bg-white/10 backdrop-blur-sm p-6 mb-8 border border-white/5">
                <h4 className="text-black text-base font-semibold mb-4 flex items-center">
                  <span className="h-8 w-8 rounded-lg bg-secondary/20 flex items-center justify-center text-secondary mr-3">
                    <FiMapPin size={16} />
                  </span>
                  Our Location
                </h4>16, 80 Feet Rd, near Wipro Park, opposite SBI BANK, 1st Block Koramangala, Koramangala, Bengaluru, Karnataka 560034
                <p className="text-black text-sm mb-4"></p>
                <Link to="/contact" className="inline-flex items-center gap-2 text-secondary hover:text-black transition-colors font-medium text-sm group">
                  <span>Get Directions</span>
                  <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>

            <div className="md:col-span-7 lg:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-8">
              {/* Quick Links */}
              <div>
                <h4 className="text-lg font-bold text-black mb-5 pb-2 border-b border-white/10 relative">
                  <span className="relative z-10">Navigation</span>
                  <span className="absolute bottom-0 left-0 w-16 h-0.5 bg-secondary"></span>
                </h4>
                <ul className="space-y-3">
                  <li><FooterLink to="/">Home</FooterLink></li>
                  <li><FooterLink to="/branches">Theatres</FooterLink></li>
                  <li><FooterLink to="/gallery">Gallery</FooterLink></li>
                  <li><FooterLink to="/about">About Us</FooterLink></li>
                  <li><FooterLink to="/contact">Contact</FooterLink></li>
                </ul>
              </div>

              {/* Services */}
              <div>
                <h4 className="text-lg font-bold text-black mb-5 pb-2 border-b border-white/10 relative">
                  <span className="relative z-10">Celebrations</span>
                  <span className="absolute bottom-0 left-0 w-16 h-0.5 bg-secondary"></span>
                </h4>
                <ul className="space-y-3">
                  <li><FooterLink to="/branches">Birthday Parties</FooterLink></li>
                  <li><FooterLink to="/branches">Joy Fucntions</FooterLink></li>
                  <li><FooterLink to="/branches">Outdoor decorations</FooterLink></li>
                  {/* <li><FooterLink to="/branches">Proposal Events</FooterLink></li>
                  <li><FooterLink to="/branches">Corporate Events</FooterLink></li> */}
                </ul>
              </div>

              {/* Contact & Legals */}
              <div>
                <h4 className="text-lg font-bold text-black mb-5 pb-2 border-b border-white/10 relative">
                  <span className="relative z-10">Contact & Legal</span>
                  <span className="absolute bottom-0 left-0 w-16 h-0.5 bg-secondary"></span>
                </h4>
                <ul className="space-y-3 mb-6">
                  <li>
                    <a href="tel:+919880346464" className="text-black hover:text-black transition-colors duration-200 flex items-center gap-2 text-sm">
                      <span className="h-6 w-6 rounded-full bg-white/10 flex items-center justify-center text-secondary text-xs">
                        <FiPhone size={12} />
                      </span>
                      <span>+91 9880346464</span>
                    </a>
                  </li>
                  <li>
                    <a href="tel:+919986713636" className="text-black hover:text-black transition-colors duration-200 flex items-center gap-2 text-sm">
                      <span className="h-6 w-6 rounded-full bg-white/10 flex items-center justify-center text-secondary text-xs">
                        <FiPhone size={12} />
                      </span>
                      <span>+91 9986713636</span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:happybubble36@gmail.com" className="text-black hover:text-black transition-colors duration-200 flex items-center gap-2 text-sm">
                      <span className="h-6 w-6 rounded-full bg-white/10 flex items-center justify-center text-secondary text-xs">
                        <FiMail size={12} />
                      </span>
                      <span>happybubble36@gmail.com</span>
                    </a>
                  </li>
                </ul>

                <ul className="space-y-3">
                  <li><FooterLink to="/privacy-policy">Privacy Policy</FooterLink></li>
                  <li><FooterLink to="/terms-and-conditions">Terms & Conditions</FooterLink></li>
                  <li><FooterLink to="/refund-policy">Refund Policy</FooterLink></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Social Media and Newsletter Section */}
          <div className="border-t border-white/10 pt-10 pb-6">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
              <div className="md:col-span-5 lg:col-span-4">
                <h4 className="text-base font-medium text-black mb-3">Follow Us</h4>
                <div className="flex space-x-3">
                  <SocialLink href="#" icon={<FiFacebook />} label="Facebook" />
                  <SocialLink href="#" icon={<FiInstagram />} label="Instagram" />
                  <SocialLink href="#" icon={<FiTwitter />} label="Twitter" />
                  <SocialLink href="#" icon={<FiYoutube />} label="YouTube" />
                </div>
              </div>

              <div className="md:col-span-7 lg:col-span-8">
                <div className="flex flex-wrap gap-5 justify-start md:justify-end">
                  {/* <img src="/payment.png" alt="Payment Methods" className="h-7 bg-white/10 px-3 py-1 rounded-lg" /> */}
                  {/* <div className="rounded-lg flex items-center">
                    <a href="https://www.themeforest.net" target="_blank" rel="noopener noreferrer" className="text-xs ttext-black-400 px-3 py-1.5 rounded-lg bg-white/5 flex items-center border border-white/5 hover:bg-white/10 transition-colors">
                      <span className="mr-2">We Support</span>
                      <span className="bg-gradient-to-r from-primary-300 to-secondary bg-clip-text text-transparent font-bold">Premium Venues</span>
                      <FiExternalLink size={10} className="ml-1.5 ttext-black-500" />
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center">
            <p className="text-xs text-center md:text-left text-dark">
              &copy; {new Date().getFullYear()} Happy Bubble. All rights reserved. A Culinary Cinematic Experience.
            </p>
            <div className="mt-4 md:mt-0 text-xs flex flex-col md:items-end items-center gap-1">
              <div>Designed with <span className="text-secondary">♥</span> for extraordinary celebrations</div>
              <div>
                Developed by <a href="https://elitesoftwaresolutions.in" target="_blank" rel="noopener noreferrer" className="hover:text-secondary transition-colors font-medium">Elite Software Solutions</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ to, children }) {
  const location = useLocation();

  const handleClick = (e) => {
    // If we're on the same page, prevent default navigation
    // and use smooth scrolling
    if (location.pathname === to) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // For navigation to different pages, immediately jump to top
      // This will take effect after the new page loads
      window.scrollTo(0, 0);
    }
  };

  return (
    <Link
      to={to}
      className="text-black text-sm hover:text-secondary transition-colors duration-200 flex items-center group"
      onClick={handleClick}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-secondary/50 mr-2 group-hover:bg-secondary transition-colors"></span>
      {children}
    </Link>
  );
}

function SocialLink({ href, icon, label }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="group h-10 w-10 rounded-xl flex items-center justify-center transition-all duration-300 bg-white/5 hover:bg-secondary text-black hover:text-primary border border-white/10 hover:border-transparent overflow-hidden relative"
    >
      <span className="absolute inset-0 bg-gradient-to-tr from-secondary/80 via-secondary to-secondary/80 opacity-0 group-hover:opacity-100 transition-opacity"></span>
      <span className="relative z-10">
        {React.cloneElement(icon, { size: 18 })}
      </span>
    </a>
  );
} 